import request from "@/utils/request";
const croneJobBaseUrl = `${process.env.VUE_APP_CUST_CRONE_SERVICE}/api/v1/plugin`;
const TransactionJobBaseUrl = `${process.env.VUE_APP_CUST_CRONE_SERVICE}/api/v1/txn`;
const EarningBaseUrl = `${process.env.VUE_APP_CUST_CRONE_SERVICE}/api/v1/earning`;

export default {
  //-----------------------------CRONE JOBS-------------------------------//
  pushCustomerData(user_id) {
    return request({
      url: `${croneJobBaseUrl}/push-customer?email=${user_id}`,
      method: "GET",
    });
  },
  pushDocsData(user_id) {
    return request({
      url: `${croneJobBaseUrl}/push-documents?email=${user_id}`,
      method: "GET",
    });
  },
  pushKYCData(user_id) {
    return request({
      url: `${croneJobBaseUrl}/kyc-status?user_name=${user_id}`,
      method: "GET",
    });
  },
  //------------------------------TRANSACTION JOBS ------------------------//
  getAllPushTrans() {
    return request({
      url: `${TransactionJobBaseUrl}/push-transaction`,
      method: "GET",
    });
  },
  getAllTransStatus() {
    return request({
      url: `${TransactionJobBaseUrl}/get-transaction-status`,
      method: "GET",
    });
  },
  getCommitTrans() {
    return request({
      url: `${TransactionJobBaseUrl}/commit-transactions`,
      method: "GET",
    });
  },
  pushTransPinNumber(pinNumber) {
    return request({
      url: `${TransactionJobBaseUrl}/push-transaction-by-pin?pin_number=${pinNumber}`,
      method: "GET",
    });
  },
  pushTrans(selectedTxnId,remarks) {
    return request({
      url: `${TransactionJobBaseUrl}/push-transaction-by-pin?pin_number=${selectedTxnId}&remarks=${remarks}`,
      method: "GET",
    });
  },
  getTransPinStatus(transpinNumber) {
    return request({
      url: `${TransactionJobBaseUrl}/get-transaction-status-by-id?pin_number=${transpinNumber}`,
      method: "GET",
    });
  },
  getCalculateTxn() {
    return request({
      url: `${EarningBaseUrl}/calculate-partner-earning`,
      method: "GET",
    });
  },
};
